import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

export const FeatureLock = ({ title, description, testId }) => {
  const navigate = useNavigate();
  return (
    <div className="border border-zinc-700 rounded-lg p-4 bg-zinc-800/50 flex items-center justify-between gap-4" data-testid={`${testId}-locked`}>
      <div>
        <h4 className="text-white font-medium flex items-center gap-2">
          <Lock className="w-4 h-4 text-[#C41E3A]" />
          {title}
          <span className="text-xs bg-amber-500/20 text-amber-400 px-2 py-0.5 rounded-full font-normal">Pro add-on</span>
        </h4>
        <p className="text-zinc-500 text-sm mt-1">{description || 'Included with All-Access, or add it to your Basic plan.'}</p>
      </div>
      <button
        type="button"
        onClick={() => navigate('/pricing')}
        className="bg-[#C41E3A] hover:bg-[#A01830] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors shrink-0"
        data-testid={`${testId}-unlock-btn`}
      >
        Unlock
      </button>
    </div>
  );
};
